import { render, staticRenderFns } from "./crud_locations.vue?vue&type=template&id=c3299e7a&scoped=true"
import script from "./crud_locations.vue?vue&type=script&lang=js"
export * from "./crud_locations.vue?vue&type=script&lang=js"
import style0 from "./crud_locations.vue?vue&type=style&index=0&id=c3299e7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3299e7a",
  null
  
)

export default component.exports